import { APP_CONFIG } from 'mangools-commons/dist/configs/app'
import { parse } from 'sources/parsers/HistoryDataParser';
import ErrorCodes from 'mangools-commons/dist/constants/ErrorCodes';
import { TechnicalErrorReportService } from 'mangools-commons/dist/services/TechnicalErrorReportService';

// const FAKE_DATA = [{
//     "_id": "bb5ed66161957b0764319a1ed69dc074",
//     "kw": "seo",
//     "location_id": 0,
//     "location_label": "Anywhere",
//     "language_id": 0,
//     "location": {
//         "_id": 0,
//         "label": "Anywhere"
//     },
//     "platform_id": 1,
//     "seo": 84,
//     "seo_ts": 1546525876
// }, {
//     "_id": "bb5ed66161957b0764319a1ed69dc074",
//     "kw": "seo",
//     "location_id": 0,
//     "location_label": "Anywhere",
//     "language_id": 0,
//     "location": {
//         "_id": 0,
//         "label": "Anywhere"
//     },
//     "platform_id": 2,
//     "seo": 74,
//     "seo_ts": 1546525876
// }]

// Constants
const ENDPOINT = '/requests';

/**
 * Data source class handling communication
 * with API for keyword history data.
 */
class HistorySource {
    static getData(accessToken) {
        const requestURL = `${APP_CONFIG.API_HOST}${APP_CONFIG.API_PATH}${ENDPOINT}`;

        return fetch(requestURL, {
            method: 'GET',
            mode: 'cors',
            headers: {
                'X-Access-Token': accessToken || '',
            },
        })
            .then(response => {
                if (response.ok) {
                    return response
                        .json()
                        .then(data => ({
                            error: false,
                            payload: parse(data),
                        }))
                        .catch(ex => {
                            const payload = {
                                requestURL,
                                status: ErrorCodes.PARSE_ERROR,
                                text: ex.toString(),
                            };

                            TechnicalErrorReportService.report({ ...payload, method: 'GET' });

                            return { error: true, payload };
                        });
                } else {
                    return response.json().then(e => {
                        const payload = {
                            requestURL,
                            status: response.status,
                            text: e.error ? e.error.message : null,
                            type: e.error ? e.error.type : null,
                            retryAfter: e.error ? e.error.retry_after : null,
                        };

                        TechnicalErrorReportService.report({ ...payload, method: 'GET' });

                        return { error: true, payload };
                    });
                }
            })
            .catch(ex => {
                const payload = {
                    requestURL,
                    status: ErrorCodes.FETCH_ERROR,
                    text: ex.toString(),
                };

                TechnicalErrorReportService.report({ ...payload, method: 'GET' });

                return { error: true, payload };
            });
    }

    static delete({ accessToken }) {
        const requestURL = `${APP_CONFIG.API_HOST}${APP_CONFIG.API_PATH}${ENDPOINT}`;

        return fetch(requestURL, {
            method: 'DELETE',
            mode: 'cors',
            headers: {
                'X-Access-Token': accessToken || '',
            },
        })
            .then(response => {
                if (response.ok) {
                    return {
                        error: false,
                        payload: null,
                    };
                } else {
                    return response.json().then(e => {
                        const payload = {
                            requestURL,
                            status: response.status,
                            text: e.error ? e.error.message : null,
                            type: e.error ? e.error.type : null,
                            retryAfter: e.error ? e.error.retry_after : null,
                        };

                        TechnicalErrorReportService.report({ ...payload, method: 'DELETE' });

                        return { error: true, payload };
                    });
                }
            })
            .catch(ex => {
                const payload = {
                    requestURL,
                    status: ErrorCodes.FETCH_ERROR,
                    text: ex.toString(),
                };

                TechnicalErrorReportService.report({ ...payload, method: 'DELETE' });

                return { error: true, payload };
            });
    }
}

export default HistorySource;
